module.exports = __webpack_public_path__ + "static/media/the-dutch_drink-up.b4016a1d.jpg";